import type { Translations } from './types';
import { ru } from './ru/translations';
import { en } from './en/translations';
import { fr } from './fr/translations';
import { nl } from './nl/translations';
import { de } from './de/translations';

export type { Translations } from './types';
export const translations: Record<string, Translations> = {
    ru,
    en,
    fr,
    nl,
    de,
};
